import React from 'react'
import { Grid, Header } from 'semantic-ui-react'
import { BackToStatisticsButton } from './BackToStatisticsButton'

interface DetailHeaderProps {
  title: string
  backButton?: boolean
}

export const DetailHeader: React.FC<DetailHeaderProps> = ({ title, backButton = true }) => {
  return (
    <Grid.Row columns='equal'>
      <Grid.Column className='detail-header' textAlign='left' verticalAlign='middle'>
        <Header>
          {backButton && <BackToStatisticsButton />}
          {title}
        </Header>
      </Grid.Column>
    </Grid.Row>
  )
}
